// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__29kZS","signatureButtonsRight":"ModalSign_signatureButtonsRight__Ehreb"};